const STORAGE_KEY = "uzp_return_to";

/** Remembers where to go after the sign-in link is opened (in this tab's session). */
export function setReturnTo(path: string) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // Storage unavailable: the user lands on the dashboard home after signing in.
  }
}

/** The remembered path, once. Only same-origin paths are honoured. */
export function takeReturnTo(): string | null {
  try {
    const path = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return path?.startsWith("/") && !path.startsWith("//") ? path : null;
  } catch {
    return null;
  }
}
